"use client";
import Loader from "@/components/Loader/Loader";
import { logout } from "@/redux/features/authSlice";
import {
  APP_RESTRICTED_ROUTES,
  ToastOptions,
  VISITOR_RESTRICTED_ROUTES,
} from "@/utils/enum";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const pathname = usePathname();
  const userRoleVal = useSelector((state: any) => state.auth.userRole);
  const app_name = process.env.NEXT_PUBLIC_APP_NAME;
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    if (!app_name || !APP_RESTRICTED_ROUTES[app_name]) {
      setIsAuthorized(true);
      return;
    }

    const handleRouteProtection = () => {
      if (pathname !== "/login") {
        if (
          VISITOR_RESTRICTED_ROUTES[userRoleVal] &&
          VISITOR_RESTRICTED_ROUTES[userRoleVal]?.includes(pathname)
        ) {
          // toast.info("Unauthorized", ToastOptions);
          router.replace("/");
          setIsAuthorized(false);
          return;
        }
        if (!VISITOR_RESTRICTED_ROUTES[userRoleVal]) {
          toast.error("Please login again");
          localStorage.removeItem("token");
          dispatch(logout());
          // toast.info("Unauthorized", ToastOptions);
          router.replace("/login");
          setIsAuthorized(false);
          return;
        }
      }

      const restrictedRoutes = APP_RESTRICTED_ROUTES[app_name];
      const isRestricted = restrictedRoutes.some(
        (restrictedPath: string) =>
          pathname === restrictedPath ||
          pathname.startsWith(restrictedPath + "/"),
      );

      if (isRestricted) {
        toast.info("Page Not Found", ToastOptions);
        router.replace("/");
        setIsAuthorized(false);
        return;
      }
      setIsAuthorized(true);
    };

    handleRouteProtection();
  }, [pathname, userRoleVal]);

  if (isAuthorized === null) {
    return <Loader />;
  }

  // redirect already triggered in useEffect- render nothing
  if (!isAuthorized) {
    return null;
  }
  return children;
};
